'use memo';

import { createFileRoute } from '@tanstack/react-router';
import { DeviceAssignmentAlertsPage } from '../../-components/DeviceAssignmentAlertsPage';
import { DEVICE_ASSIGNMENT_ALERT_CATEGORY } from '../../-constants';
export const Route = createFileRoute('/_staff/devices/_list/alerts/_alerts/to-be-assigned/')({
  component: ToBeAssignedAlertsPage
});
function ToBeAssignedAlertsPage() {
  return <DeviceAssignmentAlertsPage category={DEVICE_ASSIGNMENT_ALERT_CATEGORY.TO_BE_ASSIGNED} categoryKey="toBeAssigned" />;
}